// ABOUTME: Header name and same-origin path prefixes of the dealership a screen works in.
// ABOUTME: Shared by the request-dealership store, the fetch wrapper and the Apollo link.

/** Request header naming the dealership of a catalogue, cart or offer call; mirrors the server. */
export const REQUEST_DEALERSHIP_HEADER = 'x-dealership';

/** Only same-origin calls under these paths get the header; external URLs never do. */
export const DEALERSHIP_PATH_PREFIXES = ['/api', '/configitProxy', '/configurator'];
